/**
 * ForgotPassword - "email me a reset link"
 * ----------------------------------------
 * Note the confirmation message never says whether the address was found.
 * If it did, anybody could use this form to work out who has an account -
 * which matters a great deal when some of our users are minors.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';

import { authApi } from '../services/api';
import { useI18n } from '../hooks/useI18n';

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);

    try {
      const { message } = await authApi.forgotPassword(email);
      setSent(message);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-layout">
      <div className="page-header text-center">
        <h1>{t('forgot.title')}</h1>
        <p>{t('forgot.subtitle')}</p>
      </div>

      <div className="card">
        {sent ? (
          <>
            <div className="alert alert-success">
              <Mail size={20} aria-hidden="true" />
              <div>{sent}</div>
            </div>
            <p className="text-sm text-muted" style={{ marginTop: 'var(--space-sm)' }}>
              {t('forgot.checkSpam')}
            </p>
            <Link to="/login" className="btn btn-outline btn-block" style={{ marginTop: 'var(--space-sm)' }}>
              {t('forgot.backToLogin')}
            </Link>
          </>
        ) : (
          <form className="form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}

            <div className="field">
              <label htmlFor="email">{t('forgot.email')}</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                required
                autoFocus
              />
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
              <Mail size={18} />
              {busy ? t('forgot.sending') : t('forgot.submit')}
            </button>

            <Link to="/login" className="text-sm text-center" style={{ marginTop: 'var(--space-xs)' }}>
              <ArrowLeft size={14} style={{ display: 'inline', verticalAlign: -2 }} />{' '}
              {t('forgot.backToLogIn')}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
